import { Col, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { ProjectsConstructorCard, confirmation } from '@/components';
import { RolesAndRatesForm } from './RolesAndRatesForm';
import { AddPositionDto, PositionDto, ProjectDto } from '@/core';
import { useDeletePositionMutation, useUpdatePositionMutation } from '@/redux';

type ProjectsRolesCardProps = PositionDto & {
  onClickMenuEdit: () => void;
  isEdit: boolean;
  stopEditRoleCard: (id: string) => void;
  projectData: ProjectDto;
};

export const ProjectsRolesCard = ({
  name,
  rate,
  isEdit,
  id,
  onClickMenuEdit,
  stopEditRoleCard,
  projectData,
}: ProjectsRolesCardProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const [updateRoleCard] = useUpdatePositionMutation();
  const [deletePosition] = useDeletePositionMutation();
  const affectedEmployees = projectData.employees.filter((employee) => employee.positionId === id);

  const editRoleCard = (positionData: AddPositionDto) => {
    updateRoleCard({ positionData, id })
      .unwrap()
      .then(() => stopEditRoleCard(id));
  };
  const onClickMenuDelete = () =>
    confirmation.show({
      title: t('addRoles.delete.title'),
      body: t('addRoles.delete.body', { affectedEmployeesQuantity: affectedEmployees.length }),
      isConfirmButtonDanger: true,
      onConfirm: () => deletePosition({ id }),
      confirm: 'Delete',
    });

  return (
    <ProjectsConstructorCard
      isEdit={isEdit}
      onClickMenuDelete={onClickMenuDelete}
      onClickMenuEdit={onClickMenuEdit}
      editForm={
        <RolesAndRatesForm
          handleCancel={() => stopEditRoleCard(id)}
          handleSubmit={editRoleCard}
          initialValue={{ name, rate }}
          formUid={name}
          isCancelButton
          projectData={projectData}
        />
      }
    >
      <Col span={12}>
        <Typography.Paragraph className="pe-3">{name}</Typography.Paragraph>
      </Col>
      <Col span={12}>
        <Typography.Paragraph>${rate}</Typography.Paragraph>
      </Col>
    </ProjectsConstructorCard>
  );
};
